/*
 *
 * Virtual Market
 * settings-api - Servicios
 *
 * RYNDEM 2017
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'settings-api';

/*********************** Obtener Token ***********************/
export function getToken() {
  DEBUG && console.log(OBJECT_ID + "@getToken: Petición del token");

  let requestUrl = `${API_URL}/sesiones`;
  DEBUG && console.log(OBJECT_ID  + "@getToken: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Nuevo Token ***********************/
export function putToken(token) {
  DEBUG && console.log(OBJECT_ID + "@putToken: Nuevo token o Confirmación");

  let requestUrl = `${API_URL}/sesiones`;
  DEBUG && console.log(OBJECT_ID  + "@putToken: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "put",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Finalizar Sesion ***********************/
export function finishSession(token) {
  DEBUG && console.log(OBJECT_ID + "@finishSession: Finalizar sesion");

  let requestUrl = `${API_URL}/sesiones/horaFin`;
  DEBUG && console.log(OBJECT_ID  + "@finishSession: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "put",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Concluir sesión permanentemente ***********************/
export function endSession(token) {
  DEBUG && console.log(OBJECT_ID + "@endSession: Finalizar sesion completamente");

  let requestUrl = `${API_URL}/sesiones/endprocess`;
  DEBUG && console.log(OBJECT_ID  + "@endSession: requestUrl --> " + requestUrl);

  console.log("Terminar sesión completamente")
  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** actualizar info de usuario ***********************/
export function sendUserData(token, term) {
  DEBUG && console.log(OBJECT_ID + "@sendUserData: Actualizar sesion");

  let requestUrl = `${API_URL}/sesiones/sendUserData`;
  DEBUG && console.log(OBJECT_ID  + "@sendUserData: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "put",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Iniciar boleto ***********************/
export function fetchTicket(token, idSession, idMarket, combinacion) {
  DEBUG && console.log(OBJECT_ID + "@fetchTicket: ");

  let term = {
    'idMercado': idMarket,
    'idSesion': idSession,
    'combinacion': combinacion
  }

  let requestUrl = `${API_URL}/boletos`;
  DEBUG && console.log(OBJECT_ID  + "@fetchTicket: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Finalizar boleto ***********************/
export function finishTicket(token, term) {
  DEBUG && console.log(OBJECT_ID + "@finishTicket: ");

  let requestUrl = `${API_URL}/boletos`;
  DEBUG && console.log(OBJECT_ID  + "@finishTicket: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "put",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Enviar PDF's ***********************/
export function  sendPDF(token, term) {
  DEBUG && console.log(OBJECT_ID + "@sendPDF: ");

  let requestUrl = `${API_URL}/enviarPDF`;
  DEBUG && console.log(OBJECT_ID  + "@sendPDF: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data: term
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

export function requestSetLanguage({token, language}){
  DEBUG && console.log(OBJECT_ID + "@requestSetLanguage: ");

  let requestUrl = `${API_URL}/settings`;
  DEBUG && console.log(OBJECT_ID  + "@requestSetLanguage: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "put",
    headers: {'X-AUTH-TOKEN': token},
    data: {idioma: language}
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

export function requestGetLanguage(){
  DEBUG && console.log(OBJECT_ID + "@requestGetLanguage: ");

  let requestUrl = `${API_URL}/settings`;
  DEBUG && console.log(OBJECT_ID  + "@requestGetLanguage: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "get",
    //headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

export function requestSetLastPath({token, path}){
  DEBUG && console.log(OBJECT_ID + "@requestSetLastPath: ");

  let requestUrl = `${API_URL}/sesiones/lastPath`;
  DEBUG && console.log(OBJECT_ID  + "@requestSetLastPath: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token, 'Content-Type': 'text/plain'},
    data: path
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}


// WEBPACK FOOTER //
// ./src/services/settings-api.js